import React from 'react';
import './HeroAbout.css';

function HeroAbout() {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center hero-row">

          {/* Text Section */}
          <div className="col-lg-6 col-md-12">
            <div className="hero-content">
              <h1 className="main-heading">
                <span className="heading-part heading-orange">श्री</span>
                <span className="heading-part heading-yellow">JEEVANREKHA</span>
                <span className="heading-part heading-pink">BUILDERS</span>
                <span className="heading-part heading-blue">PVT LTD</span>
              </h1>

              <h3 className="welcome-text">
                <i className="flaticon-home"></i> Welcome to
              </h3>

              <h3 className="slogan-text">
                Land of Dreams and Desires
              </h3>
            </div>
          </div>

          {/* Image Section */}
          <div className="col-lg-6 col-md-12 text-center">
            <img src="/img/prop.png" alt="Hero" className="hero-img img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroAbout;
